import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'
import { PnLShareDialogButton } from '@root/features/trade/position/pnl-position-share/ui/pnl-position-share-dialog-button'
import {
  activePairPositionAtom,
  tradingPairAtom,
} from '@root/features/trade/trading'
import { Separator as Separator_ } from '@root/shared/ui-kit'

import { InstantTradeSellBalance } from './instant-trade-sell-balance'
import { InstantTradeSwapBuy } from './instant-trade-swap-buy'
import { InstantTradeSwapGas } from './instant-trade-swap-gas'
import { InstantTradeSwapHeading } from './instant-trade-swap-heading'
import { InstantTradeSwapPnl } from './instant-trade-swap-pnl'
import { InstantTradeSwapSell } from './instant-trade-swap-sell'

export const InstantTradeSwap: React.FC = () => {
  const [position] = useAtom(activePairPositionAtom)
  const [pair] = useAtom(tradingPairAtom)

  if (!pair) {
    return (
      <Loader>
        <CircularLoader size={24} />
      </Loader>
    )
  }

  return (
    <Root>
      <Section>
        <InstantTradeSwapHeading pair={pair} swapDirection="buy" />
        <InstantTradeSwapBuy pair={pair} />
        <InstantTradeSwapGas swapType="buy" />
      </Section>
      <Separator />
      <Section>
        <InstantTradeSwapHeading pair={pair} swapDirection="sell" />
        <InstantTradeSwapSell pair={pair} />
        <InstantTradeSwapGas swapType="sell">
          <>
            {position ? (
              <PnLShareDialogButton
                withOutline
                position={position}
                pair={position.pair}
              />
            ) : undefined}
          </>
        </InstantTradeSwapGas>
      </Section>

      <Separator />
      <Footer>
        <InstantTradeSellBalance pair={pair} />
        {position ? <InstantTradeSwapPnl position={position} /> : undefined}
      </Footer>
    </Root>
  )
}

const Footer = styled.div`
  display: flex;
  gap: 6px;
  justify-content: space-between;
  align-items: center;
`

const Root = styled.div`
  display: grid;
  grid-template-rows: 1fr auto 1fr;

  padding: 10px 16px;
`

const Section = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`

const Separator = styled(Separator_)`
  width: 100%;
  margin: 8px 0;
`

const Loader = styled.div`
  display: grid;
  justify-content: center;
  align-content: center;
`
